import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { FormBuilder, FormGroup, FormArray, AbstractControl,Validators } from '@angular/forms';
import { ApiService } from 'src/app/services/api.service';
import { GlobalService } from 'src/app/services/global.service';
import { Router } from '@angular/router';
import { AlertController } from '@ionic/angular';
import { SentimentAnalysisDataGenerateComponent } from '../sentiment-analysis-data-generate/sentiment-analysis-data-generate.component';


interface SentimentResponse {
  predicted_sentiment: string;
  confidence_score: number;
  all_scores: { [key: string]: number };
}


@Component({
  selector: 'app-sentiment-analysis-model-inferencing',
  templateUrl: './sentiment-analysis-model-inferencing.component.html',
  styleUrls: ['./sentiment-analysis-model-inferencing.component.scss'],
})
export class SentimentAnalysisModelInferencingComponent  implements OnInit {

  addTextForm !: FormGroup;
  formData = {
    message: '',
    lang: 'nl',
  };

  isDataUpdated :boolean = false;

  constructor(
    private modalCtrl: ModalController,
    private fb: FormBuilder,
    private apiService:ApiService,
    private router:Router,
    private globalService:GlobalService,
    private alertController: AlertController,
  ) 
    { 
      this.addTextForm = this.fb.group({
        textArray: this.fb.array([])
      });
    }

  ngOnInit() {
    this.initializeForm();
  }

  initializeForm() {
    this.addTextForm = this.fb.group({
      message: ['', [Validators.required]],    
      lang: ['nl', [Validators.required]],   
    });
  }
  

  // onSubmit() {
  //   console.log("Form is submitted");
  //   if (this.addTextForm.invalid) return;
  
  //   const formData = this.addTextForm.value;
  
  //   this.apiService.sentimentmodelInference(formData).subscribe(
  //     async (response: SentimentResponse) => {
  //       const maxKey = Object.entries(response.all_scores).reduce(
  //         (maxEntry, currentEntry) =>
  //           currentEntry[1] > maxEntry[1] ? currentEntry : maxEntry
  //       )[0];
  
  //       const alert = await this.alertController.create({
  //         header: 'Upload Data to the server',
  //         cssClass: 'custom-alert',
  //         inputs: [
  //           {
  //             name: 'text',
  //             type: 'textarea',
  //             value: formData.message,
  //             placeholder: 'Text',
  //             disabled: true
  //           },
  //           {
  //             name: 'Sentiment',
  //             type: 'text',
  //             value: maxKey,
  //             placeholder: 'Sentiment'
  //           },
            
  //         ],
  //         buttons: [
  //           {
  //             text: 'Cancel',
  //             role: 'cancel'
  //           },
  //           {
  //             text: 'Save',
  //             handler: (data) => {
  //               console.log('Edited Data:', data);
  //             }
  //           }
  //         ]
  //       });
  
  //       await alert.present();
  //     },
  //     async (error) => {
  //       console.error('Model Inferenced error:', error);
  
  //       const alert = await this.alertController.create({
  //         header: 'Error',
  //         message: 'Something went wrong while processing the request.',
  //         buttons: ['OK']
  //       });
  
  //       await alert.present();
  //     }
  //   );

    
  // }

  async onSubmit() {
    console.log("Form is submitted");
    if (this.addTextForm.invalid) return;
  
    const formData = this.addTextForm.value;
    let formdatareceive = formData;
    this.globalService.logoutLoading();
    this.apiService.sentimentmodelInference(formData).subscribe(
      async (response: SentimentResponse) => {
        const maxKey = Object.entries(response.all_scores).reduce(
          (maxEntry, currentEntry) =>
            currentEntry[1] > maxEntry[1] ? currentEntry : maxEntry
        )[0];
  
        const modal = await this.modalCtrl.create({
          component: SentimentAnalysisDataGenerateComponent,
          backdropDismiss: false,  // Prevent closing when clicking outside
          cssClass: 'large-modal-1', //custom class for styling
          componentProps:{
            'formdatareceive':formdatareceive,
            "maxKey": maxKey,
            "responsereceive":response,

          },
        });

        modal.onDidDismiss().then((result) => {
          if (result.data) {
            console.log('Edited Data:', result.data);
            this.isDataUpdated = true;
            // Send to another API or handle form update here

          }

          this.addTextForm.get('message')?.reset(''); // Reset to an empty string

        });
      
        await modal.present();
        this.globalService.dismissLoading(); // Dismiss loading spinner

      },
      async (error) => {
        this.globalService.dismissLoading(); // Dismiss loading spinner
        console.error('Model Inferenced error:', error);
  
        const alert = await this.alertController.create({
          header: 'Error',
          message: 'Something went wrong while processing the request.',
          buttons: ['OK']
        });
  
        await alert.present();
      }
    );


    
  }
  


  closeModal() {
    if(this.isDataUpdated){
      this.modalCtrl.dismiss('true');
      this.isDataUpdated = false;

    }else{
      this.modalCtrl.dismiss();
      this.isDataUpdated = false;
    }
  }

}
